import { Typography } from '@mui/material';
import type { MeasurementsStats } from '@weft/api-definition';
import { withDefault } from '@weft/utils';
import { formatNumber } from '@weft/utils';
import React from 'react';
import { DataMetringMeasurementsTable } from '../DataMetringMeasurementsTable';

type DataMeteringContentProps = {
  measurementsStats: MeasurementsStats[];
  isLoading: boolean;
};

export const DataMeteringContent: React.FC<DataMeteringContentProps> = ({ measurementsStats, isLoading }) => {
  const totalEvents = calculateTotalQuantity(measurementsStats);

  return (
    <>
      <DataMetringMeasurementsTable
        items={withDefault(measurementsStats, [])}
        itemsCount={withDefault(measurementsStats?.length, 0)}
        loadingItems={isLoading}
        getRowId={(row) => JSON.stringify(row)}
        hideFooter={false}
        showPagination={false}
        sx={{
          paddingBottom: '115px',
        }}
      />
      <Typography
        variant="body1"
        sx={{
          position: 'absolute',
          bottom: '16px',
          left: '20px',
          display: 'flex',
          alignItems: 'baseline',
          columnGap: '6px',
        }}
      >
        <Typography variant="subtitle2">
          {formatNumber(totalEvents)}
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
        >
          Total Events
        </Typography>
      </Typography>
    </>
  );
};

const calculateTotalQuantity = (measurements: MeasurementsStats[]): number => {
  return measurements.reduce((totalQuantity, measurement) => totalQuantity + measurement.quantity, 0);
};